export default __webpack_public_path__ + "static/media/otra-vida-tattoo_tattoo.e71014dc.webp";